import { Icon } from '@design-system';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';

import { CrossSellItem } from '../Containers/CrossSell/CrossSellContext';
import { Image } from '../Image';
import { ProductPrice } from '../ProductPrice/ProductPrice';

export interface CrossSellListProps {
  items: CrossSellItem[];
  onSelect: (item: CrossSellItem) => void;
  title?: string;
}

export const CrossSellList: FC<CrossSellListProps> = ({
  items = [],
  onSelect,
  title,
}) => {
  const { t } = useTranslation('product');

  if (items.length === 0) return null;

  return (
    <section className="flex flex-col items-center gap-y-4 rounded-md border border-dashed border-divider/20 px-4 py-4">
      {title && <div className="text-center text-neutral-4">{title}</div>}
      <div
        className={classNames('grid', {
          'w-1/2 grid-cols-1': items.length === 1,
          'w-full grid-cols-2 gap-3': items.length > 1,
        })}
      >
        {items.map((item: CrossSellItem) => (
          <button
            key={item.product.id}
            className="group relative flex w-full flex-col gap-y-3"
            disabled={item.product.availability !== 'Available'}
            onClick={() => onSelect(item)}
            type="button"
          >
            <Image
              alt={item.product.title}
              className="overflow-hidden rounded-sm"
              hoverEffect={item.product.availability === 'Available'}
              src={item.product.image}
              width={256}
            />
            {item.product.availability === 'Available' && (
              <div className="absolute right-4 top-4 rounded-full border border-divider/20 bg-white p-2 text-neutral-6">
                <Icon name="ic_add" />
              </div>
            )}
            <div className="flex w-full flex-col hover:text-neutral-4">
              <div className="truncate font-bold">
                {item.product.artistName}
              </div>
              <div className="truncate">{item.product.title}</div>
              {item.product.availability === 'Available' ? (
                <ProductPrice
                  className="text-neutral-4"
                  price={Number(item.product.price)}
                />
              ) : (
                <span className="text-neutral-4">{t('soldout')}</span>
              )}
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};
